import { memo } from 'react';
import { Flex, Spinner } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getPlanPageThemeColors } from 'redux/ThemeSlice';

interface Properties {
  isVisible: boolean;
  color: string;
}

const PlanSoftLoadingOverlay = ({ isVisible, color }: Properties) => {
  const themeColors = useSelector(getPlanPageThemeColors);

  return (
    <Flex
      position='absolute'
      inset={0}
      zIndex={5}
      alignItems='center'
      justifyContent='center'
      bg={`${themeColors.surface}CC`}
      opacity={isVisible ? 1 : 0}
      pointerEvents={isVisible ? 'auto' : 'none'}
      transition='opacity 0.2s ease-in-out'
      aria-hidden={!isVisible}
    >
      <Spinner size='lg' color={color} />
    </Flex>
  );
};

export default memo(PlanSoftLoadingOverlay);
